// olap-client/src/components/chat/MobileChatList.jsx
import React, { useContext, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Context } from '../..';
import CreateChatModal from '../CreateChatModal';
import { formatChatDate } from '../../utils/dateUtils';

const MobileChatList = observer(() => {
  const { chat } = useContext(Context);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const getCompanionName = (chatItem) => {
    if (chatItem.type === 'private') {
      if (chatItem.companion) {
        const name = chatItem.companion.name || '';
        const surname = chatItem.companion.surname || '';
        const fullName = `${name} ${surname}`.trim();
        if (fullName) return fullName;
        if (chatItem.companion.email) return chatItem.companion.email;
      }
      
      if (chatItem.ChatMembers) {
        const currentUserId = JSON.parse(localStorage.getItem('user') || '{}').id;
        const otherMember = chatItem.ChatMembers.find(m => m.userId !== currentUserId);
        if (otherMember && otherMember.user) {
          const name = otherMember.user.persons_info?.name || '';
          const surname = otherMember.user.persons_info?.surname || '';
          const fullName = `${name} ${surname}`.trim();
          if (fullName) return fullName;
          if (otherMember.user.email) return otherMember.user.email;
        }
      }
      
      return 'Собеседник';
    }
    return chatItem.name || 'Чат';
  };

  // Фильтрация по группе
  const filterByGroup = (chatItem) => {
    switch (chat.chatGroupFilter) {
      case 'private':
        return chatItem.type === 'private';
      case 'groups':
        return chatItem.type === 'group';
      case 'favorites':
        return chatItem.isPinned;
      default:
        return true;
    }
  };

  const filteredChats = chat.chats.filter(chatItem => {
    if (!filterByGroup(chatItem)) return false;
    if (!searchQuery.trim()) return true;
    const name = getCompanionName(chatItem).toLowerCase();
    return name.includes(searchQuery.toLowerCase());
  });

  const groups = [
    { id: 'all', label: 'Все' },
    { id: 'private', label: 'Личные' },
    { id: 'groups', label: 'Группы' },
    { id: 'favorites', label: '⭐' }
  ];

  return (
    <div style={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      background: '#ffffff'
    }}>
    {/* Шапка с поиском и кнопкой закрытия */}
<div style={{
  padding: '12px',
  borderBottom: '1px solid #e4e4e5',
  background: '#ffffff',
  display: 'flex',
  alignItems: 'center',
  gap: '8px'
}}>
  <input
    type="text"
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
    placeholder="🔍 Поиск"
    style={{
      flex: 1,
      padding: '10px 15px',
      borderRadius: '20px',
      border: '1px solid #e4e4e5',
      outline: 'none',
      fontSize: '14px',
      background: '#f4f4f5'
    }}
  />
  
  {/* Кнопка закрытия мессенджера */}
  <button
    onClick={() => chat.closeWidget()}
    style={{
      background: 'transparent',
      border: 'none',
      fontSize: '24px',
      cursor: 'pointer',
      color: '#707579',
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'background 0.2s',
      flexShrink: 0
    }}
    onMouseEnter={(e) => e.currentTarget.style.background = '#f4f4f5'}
    onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
    title="Закрыть мессенджер"
  >
    ✕
  </button>
</div>

      {/* Табы групп */}
      <div style={{
        display: 'flex',
        borderBottom: '1px solid #e4e4e5',
        background: '#ffffff',
        overflowX: 'auto',
        scrollbarWidth: 'none'
      }}>
        {groups.map(group => {
          const isActive = chat.chatGroupFilter === group.id;
          return (
            <div
              key={group.id}
              onClick={() => chat.setChatGroupFilter(group.id)}
              style={{
                padding: '12px 16px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: isActive ? 'bold' : 'normal',
                color: isActive ? '#3390ec' : '#707579',
                borderBottom: isActive ? '2px solid #3390ec' : '2px solid transparent',
                whiteSpace: 'nowrap',
                transition: 'all 0.2s'
              }}
            >
              {group.label}
            </div>
          );
        })}
      </div>

      {/* Список чатов */}
      <div style={{ flex: 1, overflowY: 'auto' }}>
        {chat.isLoading ? (
          <div style={{ textAlign: 'center', color: '#999', marginTop: '50px' }}>
            Загрузка...
          </div>
        ) : filteredChats.length === 0 ? (
          <div style={{ textAlign: 'center', color: '#999', marginTop: '50px', padding: '20px' }}>
            {searchQuery ? 'Ничего не найдено' : 'Нет чатов'}
          </div>
        ) : (
          filteredChats.map(chatItem => (
            <div
              key={chatItem.id}
              onClick={() => {
                chat.openChat(chatItem);
                chat.setView('chat');
              }}
              style={{
                padding: '12px 16px',
                borderBottom: '1px solid #f0f0f0',
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                transition: 'background 0.2s'
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = '#f4f4f5'}
              onMouseLeave={(e) => e.currentTarget.style.background = 'white'}
            >
              <div style={{ flex: 1, overflow: 'hidden' }}>
                <div style={{ 
                  fontWeight: 'bold', 
                  display: 'flex', 
                  alignItems: 'center',
                  gap: '5px'
                }}>
                  {chatItem.isPinned && <span title="Закреплен">📌</span>}
                  {getCompanionName(chatItem)}
                </div>
                {chatItem.lastMessage && (
                <div style={{ fontSize: '11px', color: '#999' }}>
                    {formatChatDate(chatItem.lastMessage.createdAt)}
                </div>
                )}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '4px' }}>
                {chatItem.lastMessage && (
                  <div style={{ fontSize: '11px', color: '#999' }}>
                    {new Date(chatItem.lastMessage.createdAt).toLocaleTimeString([], {
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                  </div>
                )}
                {chatItem.unreadCount > 0 && (
                  <span style={{
                    background: '#3390ec',
                    color: 'white',
                    borderRadius: '50%',
                    minWidth: '22px',
                    height: '22px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '12px',
                    fontWeight: 'bold'
                  }}>
                    {chatItem.unreadCount}
                  </span>
                )}
              </div>
            </div>
          ))
        )}
      </div>

      {/* FAB — кнопка создания чата */}
      <button
        onClick={() => setShowCreateModal(true)}
        style={{
          position: 'absolute',
          bottom: '80px',
          right: '20px',
          width: '56px',
          height: '56px',
          borderRadius: '50%',
          background: '#3390ec',
          color: 'white',
          border: 'none',
          fontSize: '24px',
          cursor: 'pointer',
          boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 100
        }}
        title="Создать чат"
      >
        ✏️
      </button>

      {showCreateModal && (
        <CreateChatModal onClose={() => setShowCreateModal(false)} />
      )}
    </div>
  );
});

export default MobileChatList;